<template>
    <div class="o-search">
        <m-tabs
            :items="protectorsTypes"
            @input="build('type', $event.value)"
            :selected="query.type"
        />
        <div class="o-search__controls">
            <m-control
                v-show="query.type === 'pesticide'"
                type="search"
                label="Agrofag"
                placeholder="Znajdź..."
                name="agrofags"
                @input="build('agrofags', $event)"
                :value="query.agrofags"
            />
            <m-control
                type="search"
                label="Uprawa"
                placeholder="Znajdź..."
                name="crops"
                @input="build('crops', $event)"
                :value="query.crops"
            />
            <m-control
                type="search"
                label="Grupa środków"
                placeholder="Znajdź..."
                name="protector_types"
                model-name="protector-types"
                @input="build('protector_types', $event)"
                :value="query['protector_types']"
                :params="query.type !== 'all' ? {
                    is_pesticide_group: query.type === 'pesticide' ? 1 : 0
                } : {}"
            />
            <m-control
                type="search"
                label="Środek"
                placeholder="Znajdź..."
                name="name"
                model-name="protectors"
                @input="build('name', $event)"
                :value="query['name']"
                :params="query.type !== 'all' ? {
                    type: query.type === 'pesticide' ? 'pesticide' : 'notpesticide'
                } : {}"
            />
            <m-control
                v-show="query.type !== 'notpesticide'"
                type="search"
                label="Substancja"
                placeholder="Znajdź..."
                name="active_substances"
                model-name="active-substances"
                @input="build('active_substances', $event)"
                :value="query['active_substances']"
            />
            <m-control
                v-show="query.type === 'pesticide'"
                type="search"
                label="Producent"
                placeholder="Znajdź..."
                name="producent"
                model-name="producents"
                @input="build('producent', $event)"
                :value="query['producent']"
            />
        </div>
        <div class="l-row">
            <div class="l-row__column">
                <hr class="a-hr" />
            </div>
        </div>
        <div class="l-row">
            <m-control
                type="radio"
                label="Produkty tylko z notatką własną"
                name="note"
                @input="build('note', $event)"
                :value="query['note']"
                :items="protectorsNoteTypes"
            />
        </div>
        <div class="l-row">
            <div class="l-row__column">
                <a-button
                    type="fullwidth"
                    icon="FilterWhite"
                    @click="filterProtectors"
                    :process-on-click="true"
                >
                    Filtruj
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Wyszukiwanie zaawansowane'
    },
    computed: {
        protectorsTypes() {
            return this.$store.getters.protectorsTypes
        },
        protectorsNoteTypes() {
            return this.$store.getters.protectorsNoteTypes
        },
        query() {
            return this.$store.getters.protectorsQuery
        }
    },
    methods: {
        build(name, value) {
            this.$store.dispatch('setProtectorsSearchQuery', {
                name,
                value
            })
        },
        filterProtectors() {
            this.$router.push({ name: 'protectors' })
        }
    }
}
</script>